import { useAppContext } from "providers/AppProvider/AppProvider"
import { Navigate } from "react-router-dom"
import { getItemFromLocalStorage } from "utils/localStorage"

import { IPrivateRouteProps } from "./PrivateRouteTypes"

const PrivateRoute: React.FC<IPrivateRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const token = getItemFromLocalStorage("token")
  const { user } = useAppContext()

  const userRole = user?.roles && user?.roles?.length > 0 ? user?.roles[0] : ""
  
  if (!token) {
    return <Navigate to="/login" />
  }

  // if(userRole && !allowedRoles.includes(userRole)) {
  //   return <Navigate to="/" />
  // }

  return children
}

export default PrivateRoute
